import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getAccountUsersService = (
  request?: t.GetAccountUsersRequestType
) => {
  log.info("getAccountUsersService Request: " + JSON.stringify(request));
  const accountName =
    request && request.params ? request.params.account_name : undefined;
  let GET_ACCOUNT_USERS_API_ENDPOINT: string;
  if (accountName) {
    log.info("Filtering by Account: " + accountName);
    GET_ACCOUNT_USERS_API_ENDPOINT = `${apiCoreEndpoint}/account/user?account=${accountName}`;
  } else {
    GET_ACCOUNT_USERS_API_ENDPOINT = `${apiCoreEndpoint}/account/user`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ACCOUNT_USERS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ACCOUNT_USERS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addAccountUserService = (request: t.AddAccountUserRequestType) => {
  log.info("addAccountUserService Request: " + JSON.stringify(request));
  const ADD_ACCOUNT_USER_API_ENDPOINT = `${apiCoreEndpoint}/account/user`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_ACCOUNT_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_ACCOUNT_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteAccountUserService = (
  request: t.DeleteAccountUserRequestType
) => {
  log.info("deleteAccountUserService Request: " + JSON.stringify(request));
  const accountUserId = request.id;
  const DELETE_ACCOUNT_USER_API_ENDPOINT = `${apiCoreEndpoint}/account/user/${accountUserId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_ACCOUNT_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_ACCOUNT_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
